import React, { Component } from 'react';
import { render } from 'react-dom';
import { Alert } from 'reactstrap';
import ComplianceFormContainer from './containers/ComplianceFormContainer';
import KIRContainer from './containers/KIRContainer';
import ErrorContainer from './containers/ErrorContainer';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import * as urls from './urls'

let params = new URLSearchParams(window.location.search);
const changeId = params.get('changeId');
const bugId = params.get('bugId');
const isKIR = params.get('type') === 'kir';
const fetchUrl = isKIR ? 
`${urls.urls.newBaseUrl}${urls.getWorkItemTags(bugId)}?type=kir`:
`${urls.urls.oldBaseUrl}${urls.compliance(bugId)}`


class App extends Component {
  constructor() {
    super();
    this.state = {
      error: '',
      loading: true,
      compliance: {
          protocol: '',
          verified: ''
      },
      kirTags: {
        availableTags: {},
        presentTags: []
      }
    };
  }
  componentDidMount() {
    fetch(fetchUrl)
    .then(response => {
      if(response.status === 204) {
        this.handleError(new Promise(function(resolve) { resolve("Could not find work items with the given id")}));
        throw Error("Could not find a work item with the given id");
      } else if(response.status !== 200){
        this.handleError(response.json());
        throw Error(response.statusText);
      }
      
      return response.json();
    }).then(result => {
      if(!result || result.length < 1) {
        this.handleError(new Promise(function(resolve) { resolve("Could not find work item with the given id")}));
        throw Error("Could not find a work item with the given id");
      }
      this.setState(
        !isKIR?
        prevState => ({
          error: '',
          loading: false,
          compliance: {
            protocol: result.protocol === null ? '' : result.protocol,
            verified: result.protocol !== null
          }
        })
        :prevState => ({
            error: '',
            loading: false,
            kirTags: {
              availableTags: !result.availableTags? '' : result.availableTags,
              presentTags: !result.presentTags? '' : result.presentTags
            }
        })
      );
    }).catch(error => {
      this.handleError(new Promise(function(resolve) { resolve(error)}))
      console.log(error);
    });
  }
  componentWillUnmount() {
    this.setState = (state,callback)=>{
      return;
  };
  }


  handleError = response => {
    response.then(error => {
      this.setState(
        prevState => ({
          ...prevState.compliance,
          error: error.message || error,
          loading: false
        })
      )
    })
  }

  containerLogic(){
    if(this.state.error && this.state.error !== ''){
      return <ErrorContainer error={this.state.error} changeId={changeId} bugId={bugId}/>
    }
    else if(isKIR){
      return <KIRContainer changeId={changeId} bugId={bugId}  kirTags={this.state.kirTags}/>
    }
    else{
      return <ComplianceFormContainer changeId={changeId} bugId={bugId} compliance={this.state.compliance} />
    }
  }

  header(){
    if(this.state.error === '')
  return <b>Pull Request Id: <a href={"https://microsoft.visualstudio.com/os/_git/os.2020/pullrequest/"+changeId} target="_blank" rel="noopener noreferrer">{changeId}</a> 
    {' '} Bug Id: <a href={"https://microsoft.visualstudio.com/OS/_workitems/edit/"+bugId} target="_blank" rel="noopener noreferrer">{bugId}</a> 
    </b>
  }
  render() {
    const { loading } = this.state;
    if (loading)
      return null;

    return (
      <div className="container-fluid" style={{zoom: '125%'}}>
        <div className="row" style={{marginLeft: '0px'}} >
          <Alert color="light" fade={false} style={{padding:'initial'}}>
            {
              isKIR?<h2>KIR Compliance Check Form</h2>: <h2>Protocol Compliance Check Form</h2>
            }
            {this.header()}
          </Alert>
        </div>

        {
          this.containerLogic()
        }

        <div className="navbar navbar-fixed-bottom position-fixed">
          <hr />
          <span style={{float:'right', marginRight: '20px'}}>Support &#64; <a href="https://portal.microsofticm.com/imp/v3/incidents/create?tmpl=r2l2b3" target="_blank" rel="noopener noreferrer">CFE Toolkit Team IcM</a></span>
          <br /><br />
        </div>
      </div>
    );
  }
}

render(<App />, document.getElementById('root'));